module.exports = __webpack_public_path__ + "static/media/signOutGreen.6889bfe4.svg";